import { GraphQLClient } from 'graphql-request'

import { ProjectTranslator } from 'src/translators'
import { ProjectDetailEntity } from 'src/types'
import { getSdk } from 'src/types/generated-request'

type GetProjectInput = {
  accessToken: string
  projectId: string
}

export const useGetPromiseProject = () => {
  const loadProject = async ({
    accessToken,
    projectId,
  }: GetProjectInput): Promise<ProjectDetailEntity> => {
    const response = await getSdk(
      new GraphQLClient(process.env.GraphQLUrl ?? '', {
        headers: { 'bearer-token': accessToken },
      })
    ).getProject({ input: projectId })
    return ProjectTranslator.toDetailEntity(response.project.project)
  }

  return {
    loadProject,
  }
}
